// @flow
import * as React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';

class SidebarFilterBox extends React.Component<*> {
  render() {
    const { InputFilter } = this.props.fuzzyFilterFactory;
    return (
      <div className="filter-box">
        <InputFilter
          inputProps={{
            className: 'form-control',
            placeholder: 'Filter',
            'aria-label': 'Filter Items'
          }}
          onChange={this.props.onChange}
        />
        <Button type="submit" className="search">
          <Glyphicon glyph="search" />
        </Button>
      </div>
    );
  }
}

export default SidebarFilterBox;



// WEBPACK FOOTER //
// ./src/components/SidebarFilterBox.js